import { createContext } from "react"

const PermanenceReportContext = createContext();

export default PermanenceReportContext;